import useSWR from 'swr';
import { mcpService, isApiError } from '@dopomogai/api-client';
import { AgentKitError } from '../types';           // <-- note: normal import now
import type { McpServerItem, McpTestResult, UUID } from '@dopomogai/types';

export const useMcpServers = (agentId: UUID | null) => {
  const key = agentId ? (['mcp/servers', agentId] as const) : null;

  const { data, error, isLoading, mutate } = useSWR<McpServerItem[], AgentKitError>(
    key,
    async ([, id]: [string, UUID]) => {
      const res = await mcpService.listServers(id);
      if (isApiError(res)) throw new AgentKitError(res.message, res);
      return res;
    }
  );

  const test = async (serverId: string): Promise<McpTestResult> => {
    if (!agentId) throw new AgentKitError('Missing agent id for MCP test.');
    const res = await mcpService.testServer(agentId, serverId);
    if (isApiError(res)) throw new AgentKitError(res.message, res);
    return res;
  };

  return {
    servers: data ?? [],
    isLoading,
    error,
    test,
    mutate,
  };
};